import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Pencil, Plus, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { lieferantenAPI, mandantenAPI } from '../lib/api';
import LieferantFormModal from '../components/LieferantFormModal';

export default function LieferantenList() {
  const { slug } = useParams();
  const [mandant, setMandant] = useState(null);
  const [lieferanten, setLieferanten] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(undefined); // undefined = closed; null = create; obj = edit

  useEffect(() => {
    mandantenAPI.get(slug).then((r) => setMandant(r.data)).catch(() => {});
  }, [slug]);

  const reload = useCallback(() => {
    setLoading(true);
    return lieferantenAPI
      .list(slug, { q: q || undefined })
      .then((r) => setLieferanten(r.data))
      .catch((err) =>
        toast.error(err.response?.data?.detail || 'Lieferanten konnten nicht geladen werden')
      )
      .finally(() => setLoading(false));
  }, [slug, q]);

  // debounced reload on search input
  useEffect(() => {
    const t = setTimeout(reload, 200);
    return () => clearTimeout(t);
  }, [reload]);

  const onDelete = async (lf) => {
    if (!window.confirm(`Lieferant "${lf.name}" wirklich löschen?`)) return;
    try {
      await lieferantenAPI.remove(slug, lf.id);
      toast.success('Gelöscht');
      reload();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Löschen fehlgeschlagen');
    }
  };

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Lieferanten-Stammdaten</h1>
          {mandant && (
            <div className="muted">
              {mandant.name} · {mandant.skr_variant}
            </div>
          )}
        </div>
        <div className="header-meta">
          <button className="btn-primary" onClick={() => setEditing(null)}>
            <Plus size={14} /> Neuer Lieferant
          </button>
        </div>
      </header>

      <div className="filters">
        <label>
          Suche:
          <input
            type="search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Name oder USt-IdNr"
          />
        </label>
      </div>

      {loading ? (
        <div className="muted">Lädt…</div>
      ) : lieferanten.length === 0 ? (
        <div className="card empty">
          {q ? 'Kein Treffer.' : 'Noch keine Lieferanten — erscheinen automatisch nach KI-Extraktion oder manuell anlegen.'}
        </div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>USt-IdNr</th>
              <th>Standard-Konto</th>
              <th>USt-Satz</th>
              <th>EU</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lieferanten.map((l) => (
              <tr key={l.id}>
                <td><b>{l.name}</b></td>
                <td>{l.ust_id || '—'}</td>
                <td>{l.default_konto || <span className="muted">— Fallback</span>}</td>
                <td>{l.default_ust_satz != null ? `${Number(l.default_ust_satz)}%` : '—'}</td>
                <td>{l.is_eu_business ? '✓' : ''}</td>
                <td className="row-actions">
                  <button className="btn-text" onClick={() => setEditing(l)} title="Bearbeiten">
                    <Pencil size={14} />
                  </button>
                  <button className="btn-text" onClick={() => onDelete(l)} title="Löschen">
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <LieferantFormModal
        open={editing !== undefined}
        onClose={() => setEditing(undefined)}
        slug={slug}
        lieferant={editing || undefined}
        onSaved={reload}
      />
    </div>
  );
}
